/* Shared money formatter — the only place currency symbols come from. */
const SYMBOL_FALLBACK = { INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "AED ", SAR: "SAR ", SGD: "S$", AUD: "A$", CAD: "C$", JPY: "¥" };

export function fmtMoney(amount, currency = "USD", opts = {}) {
  const n = Number(amount || 0);
  const cur = (currency || "USD").toUpperCase();
  try {
    return new Intl.NumberFormat(cur === "INR" ? "en-IN" : "en-US", { style: "currency", currency: cur, maximumFractionDigits: opts.digits ?? (Math.abs(n) >= 1000 ? 0 : 2), ...opts.intl }).format(n);
  } catch {
    return `${SYMBOL_FALLBACK[cur] || cur + " "}${n.toLocaleString()}`;
  }
}

export function fmtReporting(m, reportingCurrency) {
  if (!m) return "";
  if (m.amount_reporting == null || m.currency === (m.reporting_currency || reportingCurrency)) return "";
  return `≈ ${fmtMoney(m.amount_reporting, m.reporting_currency || reportingCurrency)} @ ${m.rate_used}${m.rate_date ? ` (${m.rate_date})` : ""}`;
}
